import { FC } from "react";
import classNames from "classnames";
import { useFormikContext } from "formik";
import {
    AddClientDrawerStep,
    DRAWER_STEP_CONFIG,
} from "./AddClientDrawerSteps/lib";
import { AddClientMode, ClientFormSchema } from "./AddClientSteps/lib";
import styles from "./AddClientDrawerStepsContainer.module.scss";

interface Props {
    currentStep: AddClientDrawerStep;
    mode: AddClientMode;
}

export const AddClientDrawerStepper: FC<Props> = ({ currentStep, mode }) => {
    const { values } = useFormikContext<ClientFormSchema>();
    const activeId =
        currentStep === AddClientDrawerStep.MultiEntity
            ? AddClientDrawerStep.ClientDetails
            : currentStep;

    if (currentStep === AddClientDrawerStep.Result) {
        return <div className={styles.stepper} />;
    }

    const visibleSteps = DRAWER_STEP_CONFIG.filter(
        ({ id, hideInStepper }) =>
            !hideInStepper &&
            id !== AddClientDrawerStep.Result &&
            (mode === "newClient" || id !== AddClientDrawerStep.SelectPlan) &&
            (id !== AddClientDrawerStep.Invite ||
                (mode === "newClient" && values.plan.billingOwnership)),
    );
    const activeIndex = visibleSteps.findIndex(({ id }) => id === activeId);

    return (
        <div className={styles.stepper}>
            {activeIndex >= 0 && (
                <div
                    aria-hidden
                    className={styles.stepIndicator}
                    style={{ transform: `translateY(${activeIndex * 100}%)` }}
                />
            )}
            {visibleSteps.map(({ id, label }) => (
                <div
                    key={id}
                    className={classNames(styles.step, {
                        [styles.stepActive]: id === activeId,
                    })}
                >
                    {label}
                </div>
            ))}
        </div>
    );
};
